import { useState, useEffect } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    MenuItem,
    TextField,
    Typography,
    Select,
    InputLabel,
    FormControl,
} from "@mui/material";
import { apiUrl, backendHosts } from "../../../../ui-utils/apiConfig";
import axios from "axios";
import Swal from "sweetalert2";
const ResearchForm = ({ categories, selectedResearch, handleCloseModal, loadData }) => {
    const [formData, setFormData] = useState({
        category_id: "",
        cat_name: "",
        title: "",
        description: "",
        thumb_id: "",
        thumb_link: "",
        base64: "",
        filename: ""
    });

    useEffect(() => {
        if (selectedResearch) {

            setFormData({
                category_id: selectedResearch.category_id || "",
                title: selectedResearch.title || "",
                description: selectedResearch.description || "",
                thumb_id: selectedResearch?.thumbnail_id || "",
                cat_name: selectedResearch.category.category_name || ""
            });
            fetchThumbnail()
        }
    }, [selectedResearch]);


    const [thumbnails, setThumbnails] = useState([])


    const fetchThumbnail = async (id) => {
        let cat_Id
        if (id) {
            cat_Id = id
        } else {
            cat_Id = selectedResearch?.category_id
        }
        try {
            const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getThumbnails}${cat_Id}`)
            // const response = await httpRequest({
            //   endPoint: `${backendHosts.ADMIN}${apiUrl.getAllBlogs}`,
            //   method: "get",
            //   instance: "instanceOne",
            // });
            // return response.data?.data;
            console.log("thum", response.data.data.data)
            setThumbnails(response.data.data.data)
        } catch (error) {
            throw new Error(error.message);
        }
    }

    /** Handle Input Change */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

    };



    /** Handle Thumbnail Selection */
    const handleThumbnailChange = (id) => {
        setFormData((prev) => ({ ...prev, thumb_id: id }));
    };

    /** Handle Form Submit */
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("formDAta", formData, selectedResearch?.id)
        const payload = {
            data: {
                category_id: formData.category_id,
                title: formData.title,
                description: formData.description,
                thumb_id: formData.thumb_id,
                type: formData.cat_name,
                base64: formData.base64
            }
        }

        console.log("payload", payload)

        try {

            const response = await axios.put(`${backendHosts.ADMIN}${apiUrl.updateResearch}${selectedResearch?.id}`, payload)
            console.log("reponse.data", response.data)
            if (response?.data?.success && response?.data?.status == 200) {
                handleCloseModal()
                loadData()
                Swal.fire({
                    html: `<h2 style="font-size: 24px; font-family: 'cardiuma-regular' !important;">
                    Updated Successfully!
                </h2>`,
                    icon: "success",
                    willOpen: () => {
                        const swalContainer = document.querySelector(".swal2-container");
                        if (swalContainer) {
                            swalContainer.style.zIndex = "2000";
                        }
                    },
                });
            }

        }
        catch (error) {
            console.log("error", error.message);
            Swal.fire({
                icon: "Somthing Went Wrong",
                title: "Oops...",
                html: `<p style="font-size: 24px ; fontFamily:'cardiuma-regular', sans-serif !important;">${error.message}!</p>`,
                text: `!`,
                willOpen: () => {
                    const swalContainer = document.querySelector(".swal2-container");
                    if (swalContainer) {
                        swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                    }
                },
            });
        }

    };


    const handleDelete=async(e)=>{
        try {
            e.preventDefault()
            const response = await axios.delete(`${backendHosts.ADMIN}${apiUrl.deleteResearch}${selectedResearch?.id}`)
            console.log("reponse.data", response.data)
            if (response?.data?.success && response?.data?.status == 200) {
                handleCloseModal()
                loadData()
                Swal.fire({
                    html: `<h2 style="font-size: 24px; font-family: 'cardiuma-regular' !important;">
                    Deleted Successfully!
                </h2>`,
                    icon: "success",
                    willOpen: () => {
                        const swalContainer = document.querySelector(".swal2-container");
                        if (swalContainer) {
                            swalContainer.style.zIndex = "2000";
                        }
                    },
                });
            }

        }
        catch (error) {
            console.log("error", error.message);
            Swal.fire({
                icon: "Somthing Went Wrong",
                title: "Oops...",
                html: `<p style="font-size: 24px ; fontFamily:'cardiuma-regular', sans-serif !important;">${error.message}!</p>`,
                text: `!`,
                willOpen: () => {
                    const swalContainer = document.querySelector(".swal2-container");
                    if (swalContainer) {
                        swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                    }
                },
            });
        }
    }

    return (
        <Card sx={{ maxWidth: 800, margin: "0 auto", mt: 4, borderRadius: 2, boxShadow: 3 }}>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Update Research
                </Typography>

                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                    <Grid container spacing={3}>
                        {/* Category Dropdown */}
                        <Grid item xs={12}>
                            <FormControl fullWidth required >
                                <InputLabel>Category</InputLabel>
                                <Select
                                    name="category_id"
                                    value={formData.category_id}
                                    onChange={(e) => {
                                        const selectedId = e.target.value;
                                        const selectedCategory = categories.find((cat) => cat.id === selectedId);
                                        console.log("helloo", selectedCategory)
                                        setFormData((prev) => ({
                                            ...prev,
                                            category_id: selectedId,
                                            cat_name: selectedCategory?.category_name || "",
                                            thumb_id: ""
                                        }));

                                        fetchThumbnail(selectedId)
                                    }}
                                    label="Category"
                                >
                                    {categories.map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>
                                            {cat.category_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>



                        {/* Title */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                name="title"
                                label="Title"
                                variant="outlined"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </Grid>

                        {/* Description */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                name="description"
                                label="Description"
                                variant="outlined"
                                value={formData.description}
                                onChange={handleChange}
                                multiline
                                rows={4}
                                required
                            />
                        </Grid>

                        {/* Thumbnail Dropdown */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" gutterBottom>
                                Select Thumbnail
                            </Typography>

                            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                {thumbnails
                                    .map((thumb) => (
                                        <Box
                                            key={thumb.id}
                                            onClick={() => setFormData((prev) => ({ ...prev, thumb_id: thumb.id }))}
                                            sx={{
                                                border: formData.thumb_id === thumb.id ? "2px solid #1976d2" : "2px solid transparent",
                                                borderRadius: 2,
                                                cursor: "pointer",
                                                overflow: "hidden",
                                                width: 80,
                                                height: 80,
                                                transition: "border 0.2s",
                                            }}
                                        >
                                            <img
                                                src={thumb.image_link}
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                        </Box>
                                    ))}
                            </Box>


                        </Grid>


                        {/* PDF Upload */}
                        <Grid item xs={12}>
                            <Button variant="outlined" component="label">
                                Upload PDF
                                <input
                                    type="file"
                                    hidden
                                    accept="application/pdf"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            const reader = new FileReader();

                                            // Only access reader.result here, after file is loaded
                                            reader.onloadend = () => {

                                                setFormData((prev) => ({
                                                    ...prev,
                                                    filename: file.name,
                                                    base64: reader.result,
                                                }));
                                            };

                                            reader.readAsDataURL(file); // starts reading the file
                                        }
                                    }}
                                />
                            </Button>

                            {formData.filename && (
                                <Box mt={1}>
                                    <Typography variant="subtitle2">Selected File: {formData.filename}</Typography>
                                </Box>
                            )}
                        </Grid>


                        {/* Submit Button */}
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                {/* Submit Button */}
                                <Grid item xs={6}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{
                                            background: "#6cd13d99",
                                            color: "white",
                                            "&:hover": {
                                                background: "#6cd13d99", // same background color
                                                color: "white",          // same text color
                                            },
                                        }}

                                        fullWidth
                                        onClick={handleSubmit}
                                        disabled={
                                            !formData.category_id ||
                                            !formData.title ||
                                            !formData.description ||
                                            !formData.thumb_id ||
                                            !formData.base64
                                        }
                                    >
                                        Update
                                    </Button>
                                </Grid>

                                {/* Delete Button */}
                                <Grid item xs={6}>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="error"
                                        fullWidth
                                    onClick={handleDelete} 
                                    >
                                        Delete
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ResearchForm;
